import { URLUSER } from "../utils/constants";
import { fetchWithApiKey } from "./fetchWithApiKey";

const getSuspender = (promise) => {
  let status = "pending";
  let response;

  const suspender = promise.then(
    (res) => {
      status = "success";
      response = res;
    },
    (err) => {
      status = "error";
      response = err;
    }
  );

  const read = () => {
    switch (status) {
      case "pending":
        throw suspender;
      case "error":
        throw response;
      default:
        return response;
    }
  };

  return { read };
};

/* export function fetchData(url) {
  const promise = fetch(url)
    .then((response) => response.json())
    .then((json) => json);

  return getSuspender(promise);
} */

export const getUserLogged = async (id) => {
  console.log('🔍 fetchData.getUserLogged - ID:', id);
  
  try {
    const token = localStorage.getItem('sanctum_token');
    const data = await fetchWithApiKey(`${URLUSER}${id}`, {
      method: 'GET',
      headers: token ? {
        'Authorization': `Bearer ${token}`
      } : {}
    });
    
    console.log('✅ Usuario obtenido:', data);
    return data;
  } catch (error) {
    console.error('❌ Error obteniendo usuario:', error);
    throw error;
  }
}